import { faExclamationCircle, faUserMinus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Flex, Text, TextButton, useOpenModal } from '@modusign/design-system';
import { useCallback } from 'react';

import { ResourceModalFooter } from '@app/components/Modal/ResourceModal';
import BatchPermissionGrantConfirmationModal from '@app/features/authorization/batchPermissionGrant/components/BatchPermissionGrantConfirmationModal';

export interface BatchPermissionGrantModalFooterProps {
  disabled: boolean;
  resourceName: '문서' | '템플릿' | '외부문서';
  shouldAlertGrantAllMember: boolean;
  targetCount: number;
  isLoading: boolean;
  onCancel: () => void;
  onGrant: () => Promise<void>;
  onResetGrant: () => Promise<void>;
}

function BatchPermissionGrantModalFooter({
  disabled,
  resourceName,
  shouldAlertGrantAllMember,
  targetCount,
  isLoading,
  onCancel,
  onGrant,
  onResetGrant,
}: BatchPermissionGrantModalFooterProps) {
  const openModal = useOpenModal();

  const handleClick = useCallback(
    (type: '변경' | '제거') => () => {
      openModal((modalProps) => (
        <BatchPermissionGrantConfirmationModal
          action={type}
          {...modalProps}
          closeButtonLabel="취소"
          confirmButtonLabel="적용"
          resourceName={resourceName}
          targetCount={targetCount}
          title={`일괄 공유 ${type === '제거' ? type : ''} 안내`}
          variant="warning"
          onConfirm={type === '제거' ? onResetGrant : onGrant}
        />
      ));
    },
    [onGrant, onResetGrant, openModal, resourceName, targetCount]
  );

  return (
    <ResourceModalFooter alignItems="center" justifyContent="space-between">
      {shouldAlertGrantAllMember ? (
        <Flex flex="auto" sx={{ gap: 1 }}>
          <Text color="textPrimaryDark">
            <FontAwesomeIcon icon={faExclamationCircle} style={{ marginRight: 3 }} />
            <Text fontSize="14px" fontWeight="medium">
              주의
            </Text>
          </Text>
          <Text>모든 멤버에게 공유됩니다.</Text>
        </Flex>
      ) : (
        <TextButton onClick={handleClick('제거')}>
          <Box as={FontAwesomeIcon} icon={faUserMinus} mr={1} />
          일괄 공유 제거
        </TextButton>
      )}
      <Box>
        <Button onClick={onCancel}>취소</Button>
        <Button
          disabled={disabled}
          isLoading={isLoading}
          ml={3}
          variant="primary"
          onClick={handleClick('변경')}
        >
          공유
        </Button>
      </Box>
    </ResourceModalFooter>
  );
}

export default BatchPermissionGrantModalFooter;
